(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-rider-article"]) return;
  try {
    
(function () {
  function prepareTables(scope) {
    scope.querySelectorAll('[data-rider-article-content]').forEach(function (content) {
      content.querySelectorAll('table').forEach(function (table) {
        if (table.parentElement.classList.contains('lh-rider-article__table')) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'lh-rider-article__table';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', content.dataset.tableLabel);
        var headers = Array.prototype.map.call(table.querySelectorAll('thead th'), function (cell) {
          return cell.textContent.trim();
        });
        var figureIndex = headers.findIndex(function (label) { return /amount|charge|fee|price|cost/i.test(label); });
        var lotIndex = headers.findIndex(function (label) { return /lot|marking|colour|color/i.test(label); });
        var ruleIndex = headers.findIndex(function (label) { return /rule/i.test(label); });
        if (!table.dataset.mobileOrder) {
          table.dataset.mobileOrder = figureIndex > -1 ? 'amount' : (lotIndex > -1 ? 'lot' : 'stack');
        }
        table.dataset.mobileDensity = table.querySelectorAll('tbody tr').length > 8 ? 'dense' : 'cards';
        table.querySelectorAll('thead th').forEach(function (cell) { cell.setAttribute('scope', 'col'); });
        table.querySelectorAll('tbody th').forEach(function (cell) { cell.setAttribute('scope', 'row'); });
        table.querySelectorAll('tbody tr').forEach(function (row) {
          Array.prototype.forEach.call(row.children, function (cell, index) {
            cell.dataset.mobileLabel = headers[index] || '';
            if (index === figureIndex || (figureIndex < 0 && index === lotIndex)) {
              cell.dataset.mobileRole = 'figure';
            } else if (index === ruleIndex) {
              cell.dataset.mobileRole = 'rule';
            } else if (cell.tagName === 'TH') {
              cell.dataset.mobileRole = 'label';
            } else {
              cell.dataset.mobileRole = 'detail';
            }
          });
        });
        var hint = document.createElement('p');
        hint.className = 'lh-rider-article__table-hint';
        hint.id = 'lh-rider-table-hint-' + Math.random().toString(36).slice(2);
        hint.textContent = 'Swipe left or right to compare';
        wrapper.setAttribute('aria-describedby', hint.id);
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(hint);
        wrapper.appendChild(table);
      });
    });
  }
  /* The admin stores article bodies through a sanitiser that lowercases
     viewBox to viewbox. An SVG without the camel-case attribute does not
     scale, so every guide diagram would render at its fixed pixel size.
     Restore the name in the browser; the drawings themselves are untouched. */
  function restoreSvgViewBox(scope) {
    scope.querySelectorAll('[data-rider-article-content] svg').forEach(function (svg) {
      var value = svg.getAttribute('viewbox');
      if (value && !svg.hasAttribute('viewBox')) {
        svg.removeAttribute('viewbox');
        svg.setAttribute('viewBox', value);
      }
    });
  }
  prepareTables(document);
  restoreSvgViewBox(document);
  document.addEventListener('shopify:section:load', function (event) {
    prepareTables(event.target);
    restoreSvgViewBox(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-riding-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(scope) {
    scope.querySelectorAll('[data-hub-hero]').forEach(function (root) {
      var video = root.querySelector('video');
      var button = root.querySelector('[data-hero-video-toggle]');
      if (!video || !button || root.dataset.videoReady) return;
      root.dataset.videoReady = 'true';
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var masthead = root.querySelector('.lh-hub-masthead');
      function sync() { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; }
      function play() { var result = video.play(); if (result && result.catch) result.catch(sync); }
      video.muted = true;
      video.addEventListener('playing', function () { masthead.classList.add('has-video-frame'); sync(); });
      video.addEventListener('pause', sync);
      video.addEventListener('error', function () { masthead.classList.remove('has-video-frame'); button.hidden = true; });
      button.addEventListener('click', function () { if (video.paused) play(); else video.pause(); });
      if (motion.addEventListener) motion.addEventListener('change', function () { if (motion.matches) video.pause(); });
      button.hidden = false;
      sync();
      if (!motion.matches && !(navigator.connection && navigator.connection.saveData)) play();
    });
  }
  initHero(document);
  document.addEventListener('shopify:section:load', function (event) { initHero(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hints = {
    long: 'Pressure at the forehead and back with room at the sides points to a longer oval head. Try a long-oval model.',
    intermediate: 'Even pressure around the crown points to an intermediate oval, the most common head shape.',
    round: 'Pressure at the temples with extra room at the forehead and back may point to a rounder fit. Treat this as a clue and try the exact model on.'
  };

  function initSizeGuide(scope) {
    var shapeGrid = scope.querySelector('[data-lh-shapes]');
    var hint = scope.querySelector('[data-lh-shape-hint] p');
    if (!shapeGrid || !hint) return;
    var buttons = shapeGrid.querySelectorAll('[data-shape]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        hint.textContent = hints[button.getAttribute('data-shape')] || '';
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lh-size-guide]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
